import { Card, CardContent, Typography, Grid } from '@mui/material'
import { useTranslate } from 'react-admin'

import announces from './announces.json'
import { map, split } from 'lodash/fp'

export const Announce: React.FC = () => {
  const translate = useTranslate()
  return (
    <Card raised sx={{ width: '1280px', marginTop: '1em' }}>
      <CardContent>
        <Typography variant="body1">
          {translate('resources.announce.title')}
        </Typography>
        <br />
        {map((item: { date: string; content: string }) => {
          const { date, content } = item
          return (
            <Grid container sx={{ ml: '2em' }}>
              <Grid item xs={2}>
                <Typography variant="body2">{date}</Typography>
              </Grid>
              <Grid item xs={10}>
                {map((line: string) => (
                  <Typography variant="body2">{line}</Typography>
                ))(split('\n')(content))}
              </Grid>
            </Grid>
          )
        })(announces)}
      </CardContent>
    </Card>
  )
}
